import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'gatsby';
import SEO from '../components/SEO';
import Call from '../components/Call';
import Img from 'gatsby-image';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';

const Content_main = props => {
    return (
      <React.Fragment>
        <div className="strip strip-white strip-diagonal">
         {props.content_object.category.map(edge4 => (
              edge4.node.frontmatter.category_content ?
                
                <div className="intro pb-2"  key={edge4.node.frontmatter.path}>
                <SEO 
                  title={edge4.node.frontmatter.title} 
                  description={edge4.node.frontmatter.description} 
                />
                  <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h1>{edge4.node.frontmatter.title}</h1>
                        </div>
                    </div>
                  </div>
                </div>
              :null
          ))}
        <div className="container pb-6">
        {props.content_object.category.map(edge8 => (
          edge8.node.frontmatter.category_content ?
              edge8.node.frontmatter.category != "das-unternehmen" ?
          <Carousel 
            swipeable = {true}
            emulateTouch
            showThumbs = {false}
            showIndicators = {true}
            autoPlay = {true}
            infiniteLoop = {true}
          >
          {props.content_object.category_subs
            .filter(edge5 => edge5.node.frontmatter.featuredImage && edge5.node.frontmatter.featuredImage.childImageSharp)
            .map(edge5 => (

                <div key={edge5.node.frontmatter.title}>



                <Link to={edge5.node.frontmatter.path}>
                        <Img fluid={edge5.node.frontmatter.featuredImage.childImageSharp.fluid}/>
                        </Link>
                      <p className="legend">
                          <Link to={edge5.node.frontmatter.path}>{edge5.node.frontmatter.title}</Link>
                      </p>
                </div>
                
              
            
          ))}
          </Carousel>
          :null
          :null
        ))}
        {props.content_object.category.map(edge => (
              edge.node.frontmatter.category_content ?
                <div className="container pt-4 pt-md-6" key={edge.node.frontmatter.title}>
                <div className="row justify-content-start">
                    <div className="col-12 col-md-8 pl-md-0">
                    <div className="service service-single">
                        
                        <div className="content" dangerouslySetInnerHTML={{ __html: edge.node.html }} />
                    </div>
                    </div>
                    <div className="col-md-4 d-md-none d-lg-inline pr-md-0">
              <nav id="sidebar">
              <div className="sidebar-header">
              
                  <h3>Übersicht {edge.node.frontmatter.category}</h3>
              </div>
                <ul className="list-unstyled components">
                  {props.content_object.category.map(edge2 => (
                    edge2.node.frontmatter.category == edge.node.frontmatter.category && !edge2.node.frontmatter.category_content?
                        <li key={edge2.node.frontmatter.title}>
                          <Link to={edge2.node.frontmatter.path}>{edge2.node.frontmatter.title}</Link> 
                        </li>
                    : null
                  ))}
                    {edge.node.frontmatter.category == "werbetechnik" ?
                    <li><Link to="/bildgroessenberechnung">Bildgrößenrechner</Link></li>
                    :null}
                    {edge.node.frontmatter.category == "werbetechnik" ?
                      <li><Link to="/farbmuster">Farbmuster</Link></li>
                      
                    :null}
                    <li><Link to={edge.node.frontmatter.category}>Zurück zur Übersicht</Link></li>
                </ul>
              </nav>
            
            </div>
                </div>
                </div>
                :null
                ))}
      <div className="container pt-2">
        <Call button />
      </div>
      </div>
      </div>
      </React.Fragment>
    )
  }
  
  export default Content_main